import { render, staticRenderFns } from "./GlobalQuestionWindow.vue?vue&type=template&id=6490692b&scoped=true&"
import script from "./GlobalQuestionWindow.vue?vue&type=script&lang=js&"
export * from "./GlobalQuestionWindow.vue?vue&type=script&lang=js&"
import style0 from "./GlobalQuestionWindow.vue?vue&type=style&index=0&id=6490692b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6490692b",
  null
  
)

export default component.exports